import { render } from "./Navigation.vue?vue&type=template&id=56b5035e&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=56b5035e&scoped=true&lang=css"

import exportComponent from "/home/user/Desktop/enon-projects/fimit-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b5035e"]])

export default __exports__